module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title78"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title78"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781783830763_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781783830763_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_dedicationPage",
    attrs: {
      "href": "#/e9781783830763_ded01"
    }
  }, [_c('span', [_vm._v("Dedication")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783830763_fm02"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PREFACE")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781783830763_ack01"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGEMENTS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783830763_fm03"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTRODUCTION")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781783830763_p01"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Section 1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CAUSES OF POVERTY")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c01"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 1")]), _vm._v(" - THE CAUSES OF POVERTY IN PRE-INDUSTRIAL BRITAIN")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c02"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 2")]), _vm._v(" - THE CAUSES OF POVERTY IN THE INDUSTRIAL AGE")])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781783830763_p02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Section 2")]), _vm._v(" - THE RESPONSES TO POVERTY")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 3")]), _vm._v(" - EARLY STATE INTERVENTION")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("CHARITY IN PRE-INDUSTRIAL BRITAIN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("POOR LAWS IN THE NINETEENTH CENTURY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("CHARITY AND SELF-HELP IN THE INDUSTRIAL AGE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 7")]), _vm._v(" - THE WELFARE STATE")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783830763_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Chapter 8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("DESTITUTE CHILDREN – A CASE STUDY")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781783830763_bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Section 3")]), _vm._v(" - SEARCHING FOR POOR AND PAUPER ANCESTORS")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_appendix",
    attrs: {
      "href": "#/e9781783830763_app01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix 1")]), _vm._v(" - GETTING STARTED")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_appendix",
    attrs: {
      "href": "#/e9781783830763_app02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix 2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE RECORDS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_appendix",
    attrs: {
      "href": "#/e9781783830763_app03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix 3")]), _vm._v(" - FURTHER READING")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_appendix",
    attrs: {
      "href": "#/e9781783830763_app04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix 4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("USEFUL WEBSITES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_appendix",
    attrs: {
      "href": "#/e9781783830763_app05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Appendix 5")]), _vm._v(" - NOTES AND REFERENCES")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781783830763_ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INDEX")])])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d630a71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783830763_toc01.vue
// module id = 63
// module chunks = 0